/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_Step_ShippedInputs */

const en_scene_frontrow_step_shipped = /** @type {(inputs: Scene_Frontrow_Step_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped`)
};

/**
* | output |
* | --- |
* | "Shipped" |
*
* @param {Scene_Frontrow_Step_ShippedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_step_shipped = /** @type {((inputs?: Scene_Frontrow_Step_ShippedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_Step_ShippedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_step_shipped(inputs)
});